import { createContext } from "react";

export type FooterContextType = {
    showFooter: boolean;
    setShowFooter: (show: boolean) => void;
};

const FooterContext = createContext<FooterContextType | undefined>(undefined);

export default FooterContext;